import axios from 'axios'

export const ImageToBase64 = async (img: string) => {
  const result = await axios.get(img, {
    responseType: 'arraybuffer',
  })
  return Buffer.from(result.data, 'binary').toString('base64')
}
